"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import * as Aria from 'react-aria-components';
import styles from './Calendar.module.scss.mjs';
import { CalendarHeader } from './components/CalendarHeader/CalendarHeader.mjs';

const Calendar = () => {
  return /* @__PURE__ */ jsxs(Aria.Calendar, { className: styles.calendar, children: [
    /* @__PURE__ */ jsx(CalendarHeader, {}),
    /* @__PURE__ */ jsx(Aria.CalendarGrid, { weekdayStyle: "short", children: (date) => /* @__PURE__ */ jsx(Aria.CalendarCell, { date }) })
  ] });
};

export { Calendar, Calendar as default };
//# sourceMappingURL=Calendar.mjs.map
